import request from '@/plugins/axios'

// 查询部门分页
export function deptPage(data) {
    return request({
        url: '/sys/dept/page',
        method: 'post',
        data: data
    })
}

// 查询部门列表
export function deptList(data) {
    return request({
        url: '/sys/dept/list',
        method: 'post',
        data: data
    })
}

// 查询部门详细
export function deptDetail(id) {
    const data = {
        id : id
    };
    return request({
        url: '/sys/dept/detail',
        method: 'post',
        data
    })
}

// 查询部门树结构
export function deptTree(data) {
    return request({
        url: '/sys/dept/tree',
        method: 'post',
        data
    })
}

// 查询部门下拉树结构
export function deptTreeSelect(data) {
    return request({
        url: '/sys/dept/treeSelect',
        method: 'post',
        data
    })
}

// 根据角色ID查询部门下拉树结构
export function treeByRolMenu(roleId) {
    const data = {
        roleId : roleId
    };
    return request({
        url: '/sys/dept/treeByRolMenu/',
        method: 'post',
        data
    })
}

// 查询部门列表（排除节点）
export function deptListExclude(id) {
    const data = {
        id : id
    };
    return request({
        url: '/sys/dept/list/exclude/',
        method: 'post',
        data
    })
}

// 新增部门
export function deptAdd(data) {
    return request({
        url: '/sys/dept/add',
        method: 'post',
        data: data
    })
}

// 修改部门
export function deptUpdate(data) {
    return request({
        url: '/sys/dept/update',
        method: 'post',
        data: data
    })
}

// 删除部门
export function deptDelete(id) {
    const data = {
        id: id
    };
    return request({
        url: '/sys/dept/delete/',
        method: 'post',
        data
    })
}
// 街道
export function streetList(data) {
    return request({
        url: '/sys/dept/jdList',
        method: 'post',
        data
    })
}
// 园区初审部门
export function yqcsList(data) {
    return request({
        url: '/sys/dept/kcjCsList',
        method: 'post',
        data
    })
}
// 分配部门
export function taskDept(data) {
    return request({
        method: 'post',
        url: 'sys/dept/treeSelectPd',
        data
    })
}
// 街道 下部门
export function deptTreeList(data) {
    return request({
        url: 'sys/dept/getTaskDeptList',
        data,
        method: 'post'
    })
}